/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import moment from 'moment';
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import config from '../../config/config';
import DashboardSection from '../DashboardContainer/DashboardSection';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import BarLineChart from './monthlyTrendChartNew/monthlyTrendChartNew';
import MatchingComparsionChart from './monthlyTrendChartNew/MatchingComparsionChart';
import MetricCard from './MatrixCard/MatrixCard';
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";

const { API_BASE_URL } = config;

const GLChartRepresentation = () => {

    const token = useSelector((state) => state.auth.djangoAccessToken);
    const roles = useSelector((state) => state.auth.djangoRoles);
    const userInfo = useSelector((state) => state.auth.djangoUserInfo);
    const history = useHistory();
    const location = useLocation();
    const initialFilters = location.state || {
        entityData: null,
        ctlNameData: null,
        ctlTwoNameData: null,
        ctlThreeNameData: null,
        lastOpenRefreshDate: null,
        lastClosedRefreshDate: null,
    };

    const { showPopup } = usePopupManager();
    const [showApplyTrend, setShowApplyTrend] = useState(true);
    const [showApplyComparsion, setShowApplyComparsion] = useState(false);

    const [showDashboard, setShowDashboard] = useState(false);
    const [showDashboardComparsion, setshowDashboardComparsion] = useState(false);
    const [isLoading, setIsLoading] = useState();
    const [showFilters, setShowFilters] = useState(true);
    const [hasApplied, setHasApplied] = useState(false);
    const [filters, setFilters] = useState(initialFilters);
    const [entityOptions, setEntityOptions] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);
    const [ctlNameOptions, setCtlNameOptions] = useState([]);
    const [ctlTwoNameOptions, setCtlNameTwoOptions] = useState([]);
    const [ctlThreeNameOptions, setCtlThreeNameOptions] = useState([]);
    const [entity, setEntity] = useState();
    const [vendor, setVendor] = useState();
    const [ctlName, setCtlName] = useState();
    const [ctlTwoName, setCtlTwoName] = useState();
    const [ctlThreeName, setCtlThreeName] = useState();
    const itemsPerPage = 100;
    const [selectedPage, setSelectedPage] = useState();
    const [data, setData] = useState([]);
    const [startPage, setStartPage] = useState(0);
    const [endPage, setEndPage] = useState(100);
    const [dataLoading, setdataLoading] = useState(false);
    const [LastRefreshOpenDate, setLastRefreshOpenDate] = useState("");
    const [LastRefreshCloseDate, setLastRefreshCloseDate] = useState("");
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [labelsTrends, setLabelsTrends] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [newlyCreatedCount, setNewlyCreatedCount] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [newlyCreatedAmount, setNewlyCreatedAmount] = useState([]);

    const [labelsComparsion, setLabelsComparsion] = useState([]);
    const [totalFromCount, setTotalFromCount] = useState([]);
    const [matchingCount, setMatchingCount] = useState([]);
    const [fromAmount, setFromAmount] = useState([]);
    const [matchingdAmount, setMatchingdAmount] = useState([]);

    const [CountVariance, setCountVariance] = useState("");
    const [AmtVariance, setAmtVariance] = useState("");
    const [CountVariancePer, setCountVariancePer] = useState("");
    const [AmtVariancePer, setAmtVariancePer] = useState("");

    useEffect(() => {
        fetchData(filters);
    }, []);

    const fetchData = (filters) => {
        console.log("Fetching with", filters);
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '20px',
            flexWrap: 'wrap',
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '50px',
            overflowY: 'auto',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            overflow: 'visible',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        }),
        option: (provided) => ({
            ...provided,
            padding: '8px 12px',
        }),
    };

    const fetchEntityOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Gl-chart-entity`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setEntityOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchVendorOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Gl-chart-vendor`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setVendorOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchGLCTL1Options = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Gl-chart-ctl1`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setCtlNameOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchGLCTL2Options = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Gl-chart-ctl2`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setCtlNameTwoOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchGLCTL3Options = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/Gl-chart-ctl3`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setCtlThreeNameOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const handleEntityChange = (selected) => {
        setEntity(selected);
        setFilters(prev => ({ ...prev, entityData: selected }));
    };

    const handleVendorChange = (selected) => {
        setVendor(selected);
        setFilters(prev => ({ ...prev, entityData: selected }));
    };

    const handleCTLNameChange = (selected) => {
        setCtlName(selected);
        setFilters(prev => ({ ...prev, ctlNameData: selected }));
    };

    const handleCTLTwoNameChange = (selected) => {
        setCtlTwoName(selected);
        setFilters(prev => ({ ...prev, ctlTwoNameData: selected }));
    };

    const handleCTLThreeNameChange = (selected) => {
        setCtlThreeName(selected);
        setFilters(prev => ({ ...prev, ctlThreeNameData: selected }));
    };

    const handleApply = () => {
        const entity_data = entity?.map((m) => m?.value) || [];
        const vendor_data = vendor?.map((m) => m?.value) || [];
        const ctl1_data = ctlName?.map((m) => m?.value) || [];
        const ctl2_data = ctlTwoName?.map((m) => m?.value) || [];
        const ctl3_data = ctlThreeName?.map((m) => m?.value) || [];
        const from_month = fromDate;
        const to_month = toDate;

        if (entity_data && entity_data.length === 0) {
            showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Please select entity.",
            });
            return;
        }
        const fetchTreadmarkData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-Trend-Chart`,
                    {
                        selectedentity: entity_data,
                        selectedvendor: vendor_data,
                        selectedctl1: ctl1_data,
                        selectedctl2: ctl2_data,
                        selectedctl3: ctl3_data,
                        selectedfrommonth: from_month,
                        selectedtomonth: to_month,
                    },
                    {
                        headers: {
                            Authorization: 'Basic YWRtaW4xOjEyMw==',
                        },
                    }
                );
                setShowDashboard(true);
                setLabelsTrends(response.data.lables);
                setTotalCount(response.data.barData1);
                setNewlyCreatedCount(response.data.barData2);
                setTotalAmount(response.data.lineData1);
                setNewlyCreatedAmount(response.data.lineData2);
            } catch (error) {
                console.error('Error fetching trademark data:', error);
            } finally {
                setdataLoading(false);
                setIsLoading(false);
            }
        };
        fetchTreadmarkData();
    };

    const handleApplyComparsion = () => {
        const entity_data = entity?.map((m) => m?.value) || [];
        const vendor_data = vendor?.map((m) => m?.value) || [];
        const ctl1_data = ctlName?.map((m) => m?.value) || [];
        const ctl2_data = ctlTwoName?.map((m) => m?.value) || [];
        const ctl3_data = ctlThreeName?.map((m) => m?.value) || [];
        const from_month = fromDate;
        const to_month = toDate;

        if (entity_data && entity_data.length === 0) {
            showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Please select entity.",
            });
            return;
        }
        const fetchTreadmarkData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-Comparsion-Chart`,
                    {
                        selectedentity: entity_data,
                        selectedvendor: vendor_data,
                        selectedctl1: ctl1_data,
                        selectedctl2: ctl2_data,
                        selectedctl3: ctl3_data,
                        selectedfrommonth: from_month,
                        selectedtomonth: to_month,
                    },
                    {
                        headers: {
                            Authorization: 'Basic YWRtaW4xOjEyMw==',
                        },
                    }
                );
                setshowDashboardComparsion(true);
                setLabelsComparsion(response.data.lablesComparsion);
                setTotalFromCount(response.data.barData1);
                setMatchingCount(response.data.matching_count);
                setFromAmount(response.data.lineData1);
                setMatchingdAmount(response.data.matching_amount);
                setCountVariance(response.data.cleared_records);
                setAmtVariance(response.data.cleared_amount);
                setCountVariancePer(response.data.variance_count_pct);
                setAmtVariancePer(response.data.variance_amount_pct);
            } catch (error) {
                console.error('Error fetching trademark data:', error);
            } finally {
                setdataLoading(false);
                setIsLoading(false);
            }
        };
        fetchTreadmarkData();
    };

    const handleReset = () => {
        setShowDashboard(false);
        setHasApplied(false);
        setEntity([]);
        setVendor([]);
        setCtlName([]);
        setCtlTwoName([]);
        setCtlThreeName([]);
        setFromDate('');
        setToDate('');
    };

    const fetchLastRefreshDate = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/GL-reconcilation-last-refresh`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setLastRefreshOpenDate(formatDate(response.data.open_values));
                    setLastRefreshCloseDate(formatDate(response.data.closed_values));
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    useEffect(() => {
        fetchLastRefreshDate();
        fetchEntityOptions();
        fetchVendorOptions();
        fetchGLCTL1Options();
        fetchGLCTL2Options();
        fetchGLCTL3Options();
    }, []);

    const handlePageChange = (page) => {
        setHasApplied(true)
        setSelectedPage(page);
        let endPageVal = page * 100
        let startPageVal = endPageVal - 99
        setStartPage(startPageVal)
        setEndPage(endPageVal)
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        if (dateString.includes('T')) {
            return moment(dateString).format('DD/MM/YYYY');
        }
        return moment(dateString, 'MM/DD/YYYY').format('DD/MM/YYYY');
    };

    useEffect(() => {
        if (entityOptions.length) {
            let shouldApply = false;
            if (filters.entityData) {
                const ent = entityOptions.find((opt) => opt.value === filters.entityData?.map((m) => m?.value) || []);
                if (ent) {
                    setEntity(filters.entityData);
                    shouldApply = true;
                }
            }

            if (filters.ctlNameData) {
                const ctl1 = ctlNameOptions.find((opt) => opt.value === filters.ctlNameData?.map((m) => m?.value) || []);
                if (ctl1) {
                    setCtlName(filters.ctlNameData);
                    shouldApply = true;
                }
            }

            if (filters.ctlTwoNameData) {
                const ctl2 = ctlTwoNameOptions.find((opt) => opt.value === filters.ctlTwoNameData?.map((m) => m?.value) || []);
                if (ctl2) {
                    setCtlTwoName(filters.ctlTwoNameData);
                    shouldApply = true;
                }
            }

            if (filters.ctlThreeNameData) {
                const ctl3 = ctlThreeNameOptions.find((opt) => opt.value === filters.ctlThreeNameData?.map((m) => m?.value) || []);
                if (ctl3) {
                    setCtlThreeName(filters.ctlThreeNameData);
                    shouldApply = true;
                }
            }

            if (filters.lastOpenRefreshDate) {
                setLastRefreshOpenDate(formatDate(filters.lastOpenRefreshDate));
            }
            if (filters.lastClosedRefreshDate) {
                setLastRefreshCloseDate(formatDate(filters.lastClosedRefreshDate));
            }
            if (shouldApply) {
                console.log(shouldApply);
                setHasApplied(true);
            }
        }
    }, [entityOptions, ctlNameOptions, ctlTwoNameOptions, ctlThreeNameOptions]);


    // useEffect(() => {
    //     if (hasApplied) {
    //         handleApply();
    //     }
    // }, [selectedPage, hasApplied]);


    const handleComparisonClick = () => {
        setShowDashboard(false);
        setshowDashboardComparsion(true);
        setShowApplyComparsion(true);
        setShowApplyTrend(false);
        handleApplyComparsion();
    }

    const handleTrendClick = () => {
        setShowDashboard(true);
        setshowDashboardComparsion(false);
        setShowApplyComparsion(false);
        setShowApplyTrend(true);
        handleApply();
    }
    const MIN_MONTH = "2025-10";

    const getCurrentMonth = () => {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        return date.toISOString().slice(0, 7);
    };

    const get12MonthsBack = () => {
        const date = new Date();
        date.setMonth(date.getMonth() - 11);
        return date.toISOString().slice(0, 7);
    };

    useEffect(() => {
        const currentMonth = getCurrentMonth();
        let startMonth = get12MonthsBack();
        if (startMonth < MIN_MONTH) {
            startMonth = MIN_MONTH;
        }
        setFromDate(startMonth);
        setToDate(currentMonth);
    }, []);

    return (
        <>
            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status"></div>
                        <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
                    </div>
                </div>
            )}
            <div className={styles.main_container}>
                <div className={styles.domain_tile}>
                    <div className={styles.domain_tile_header}>Advance GL Ageing Trend Report</div>
                    <div className={styles.domain_tile_header_last}>Last Refresh Date:{LastRefreshOpenDate}</div>
                    {/* <div className={styles.domain_tile_header_last}>Last Refresh Date Open Item:{LastRefreshOpenDate}</div>
                    <div className={styles.domain_tile_header_last}>Last Refresh Date Close Item:{LastRefreshCloseDate}</div> */}
                    <button
                        className={styles.detail_view_btn}
                        onClick={() => setShowFilters(prev => !prev)}
                    >
                        {showFilters ? <FiChevronsUp size={10} /> : <FiChevronsDown size={10} />}
                    </button>
                    {showDashboard && (
                        <button
                            className={styles.detail_view_btn}
                            onClick={handleComparisonClick}
                        >
                            Comparison Chart <span className={styles.arrow}>»</span>
                        </button>
                    )}
                    {showDashboardComparsion && (
                        <button
                            className={styles.detail_view_btn}
                            onClick={handleTrendClick}
                        >
                            Trend Chart <span className={styles.arrow}>»</span>
                        </button>
                    )}
                </div>
                {showFilters && (
                    <div className={styles.filter_panel_container}>
                        <div className={styles.filter_panel_row}>
                            <div className={styles.filter_panel_col}>
                                <label className={styles.filter_label}>Entity<span style={{ color: "red" }}>*</span></label>
                                <div className={styles.filter_select_wrapper}>
                                    <Select
                                        value={entity}
                                        isMulti={true}
                                        closeMenuOnSelect={false}
                                        // onChange={setEntity}
                                        onChange={handleEntityChange}
                                        options={entityOptions}
                                        isSearchable={true}
                                        styles={customStyles}
                                    />
                                </div>
                            </div>
                            <div className={styles.filter_panel_col}>
                                <label className={styles.filter_label}>Vendor Code/Name</label>
                                <div className={styles.filter_select_wrapper}>
                                    <Select
                                        value={vendor}
                                        isMulti={true}
                                        closeMenuOnSelect={false}
                                        // onChange={setEntity}
                                        onChange={handleVendorChange}
                                        options={vendorOptions}
                                        isSearchable={true}
                                        styles={customStyles}
                                    />
                                </div>
                            </div>
                            <div className={styles.filter_panel_col}>
                                <label className={styles.filter_label}>From :</label>
                                <div className={styles.filter_select_wrapper}>
                                    <input
                                        type="month"
                                        className="form-control"
                                        value={fromDate}
                                        min="2025-10"
                                        // max={new Date().toISOString().split("T")[0]}
                                        // max={new Date().toISOString().slice(0, 7)}
                                        max={toDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={styles.filter_panel_col}>
                                <label className={styles.filter_label}>To :</label>
                                <div className={styles.filter_select_wrapper}>
                                    <input
                                        type="month"
                                        className="form-control"
                                        value={toDate}
                                        // min="2025-10"
                                        // max={new Date().toISOString().split("T")[0]}
                                        // max={new Date().toISOString().slice(0, 7)}
                                        min={fromDate}
                                        max={getCurrentMonth()}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                            </div>
                            {showApplyTrend && (
                                <div className={styles.filter_panel_col}>
                                    <div className="filter-panel-col action-buttons">
                                        <button onClick={handleApply} className="btn apply-btn">
                                            Apply
                                        </button>
                                        <button onClick={handleReset} className="btn reset-btn">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            )}
                            {showApplyComparsion && (
                                <div className={styles.filter_panel_col}>
                                    <div className="filter-panel-col action-buttons">
                                        <button onClick={handleApplyComparsion} className="btn apply-btn">
                                            Apply
                                        </button>
                                        <button onClick={handleReset} className="btn reset-btn">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {showDashboard && (
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <DashboardSection title="" disableDetailView={true}>
                                    <div className={styles.table_wrapper}>
                                        <BarLineChart
                                            labels={labelsTrends}
                                            barData1={totalCount}
                                            barData2={newlyCreatedCount}
                                            lineData1={totalAmount}
                                            lineData2={newlyCreatedAmount}
                                            barLabel1="Count"
                                            barLabel2="Newly Created Count"
                                            lineLabel1="Amount (₹ Crs)"
                                            lineLabel2="Newly Created Amount (₹ Crs)"
                                            noteData="Data from Oct 2025 to Jan 2026 is manual frozen data."
                                        />
                                    </div>
                                </DashboardSection>
                            </div>
                        </div>
                    </div>
                )}
                {showDashboardComparsion && (
                    <div>
                        <div className="row">
                            <div className="col-md-10">
                                <DashboardSection title="" disableDetailView={true}>
                                    <div className={styles.table_wrapper}>
                                        <MatchingComparsionChart
                                            labels={labelsComparsion}
                                            barData1={totalFromCount}
                                            barData2={matchingCount}
                                            lineData1={fromAmount}
                                            lineData2={matchingdAmount}
                                            barLabel1="Count"
                                            barLabel2="Newly Created Count"
                                            lineLabel1="Amount (₹ Crs)"
                                            lineLabel2="Newly Created Amount (₹ Crs)"
                                            noteData="Data from Oct 2025 to Jan 2026 is manual frozen data."
                                        />
                                    </div>
                                </DashboardSection>
                            </div>
                            <div className="col-md-2">
                                <div className="row mb-5" style={{ marginTop: "35px" }}>
                                    <div className="col-md-12">
                                        <MetricCard
                                            title="Cleared Count"
                                            value={CountVariance}
                                            percentage={CountVariancePer}
                                            subtitle=""
                                            isPositive={true}
                                            onClick={() => console.log("Card clicked")}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <MetricCard
                                            title="Cleared Amount (₹ Crs)"
                                            value={AmtVariance}
                                            percentage={AmtVariancePer}
                                            subtitle=""
                                            isPositive={true}
                                            onClick={() => console.log("Card clicked")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* </div> */}
            </div>
        </>
    );
};

export default GLChartRepresentation;